<template>
  <div
    style="
      width: 100%;
      background-color: #fff;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 999;
    "
  >
    <div class="nav">
      <div class="nav-left">
        <img src="../../assets/img/logo1.png" alt />
      </div>
      <div class="nav-right">
        <span
          v-for="(item, index) in list"
          :key="index"
          @click="navClick(index)"
          :class="navstyle == index ? 'navstyle' : ''"
          >{{ item }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: ["网站首页", "关于我们", "产品中心", "工程案列", "联系我们"],
      navstyle: 0,
    };
  },
  created() {
    this.navClick(0);
  },
  mounted() {},
  methods: {
    navClick(index) {
      this.navstyle = index;
      if (index == 0) {
        this.$router.push({ name: "home" });
      } else if (index == 1) {
        this.$router.push({ name: "about" });
      } else if (index == 2) {
        this.$router.push({ name: "product" });
      } else if (index == 3) {
        this.$router.push({ name: "engineering" });
      } else if (index == 4) {
        this.$router.push({ name: "contact" });
      }
    },
  },
  watch: {
    "$route.path": function (newVal, oldVal) {
      if (newVal === "/home") {
        this.navClick(0);
      } else if (newVal === "/about") {
        this.navClick(1);
      } else if (newVal === "/product") {
        this.navClick(2);
      } else if (newVal === "/engineering") {
        this.navClick(3);
      } else if (newVal === "/contact") {
        this.navClick(4);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  height: 90px;
  width: 85%;
  margin: 0 auto;
  display: flex;
  align-items: center;
    justify-content: space-between;
  .nav-left {
    display: flex;
    align-items: center;
    width: 35%;
    margin-right: 30px;

    img {
      height: 39px;
      width: 318px;
      line-height: 39px;
      margin-right: 20px;

      // height: 90%;
      // width: 75%;
      // line-height: 75px;
      // margin-right: 20px;
    }
  }
  .nav-right {
    font-size: 18px;
    color: #333;
    display: flex;
    width: 65%;
    justify-content: space-between;
    height: 100%;
    align-items: center;
    line-height: 75px;
    span {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
  .navstyle {
    color: #4393ed;
    border-bottom: 4px solid #4393ed;
  }
}
</style>